module.exports = "client/dist/img/logo.2ae9145c.png";